import { render, staticRenderFns } from "./_exid.vue?vue&type=template&id=40036768&scoped=true"
import script from "./_exid.vue?vue&type=script&lang=js"
export * from "./_exid.vue?vue&type=script&lang=js"
import style0 from "./_exid.vue?vue&type=style&index=0&id=40036768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40036768",
  null
  
)

export default component.exports